
import React from 'react';
import { COZY_SLEEPING_MOON } from '../constants';

interface LumiMessageProps {
  message: string;
  isThinking?: boolean;
}

const LumiMessage: React.FC<LumiMessageProps> = React.memo(({ message, isThinking }) => {
  return (
    <div className="flex flex-col items-center gap-6 transition-all duration-700 animate-in fade-in slide-in-from-bottom-8">
      <div className="relative">
        <div className={`transition-transform duration-500 ${isThinking ? 'animate-bounce' : 'hover:scale-110'}`}>
          {COZY_SLEEPING_MOON}
        </div>
        {isThinking && (
          <div className="absolute -top-6 -right-2 flex gap-2">
            <div className="w-3 h-3 bg-indigo-400 rounded-full animate-bounce shadow-[0_0_15px_rgba(129,140,248,0.8)]" style={{ animationDelay: '0s' }} />
            <div className="w-3 h-3 bg-indigo-400 rounded-full animate-bounce shadow-[0_0_15px_rgba(129,140,248,0.8)]" style={{ animationDelay: '0.2s' }} />
            <div className="w-3 h-3 bg-indigo-400 rounded-full animate-bounce shadow-[0_0_15px_rgba(129,140,248,0.8)]" style={{ animationDelay: '0.4s' }} />
          </div>
        )}
      </div>
      <div className="bg-white/10 backdrop-blur-2xl border border-white/20 p-8 rounded-[40px] max-w-md shadow-3xl relative">
        <div className="absolute -top-4 left-1/2 -translate-x-1/2 w-0 h-0 border-l-[16px] border-l-transparent border-r-[16px] border-r-transparent border-b-[16px] border-b-white/10"></div>
        <p className="text-white text-2xl md:text-3xl text-center font-medium leading-relaxed italic handwritten">
          {message}
        </p>
      </div>
    </div>
  );
});

export default LumiMessage;
